import { ICourse } from '@/shared/ICourse'
import { IWorkflowAction } from '@/shared/IWorkflowAction';
import { Tooltip, Box, Button, HStack } from '@chakra-ui/react';
import { ButtonLink } from '../navbar/ButtonLink';
import { AssignToExpertDialog } from '../review/AssignToExpertDialog';
import React from 'react';
import { SubmitSmallChangesDialog } from '../dashboard/SubmitSmallChangesDialog';

export const ActionList = (props: {
  course: ICourse;
  moduleId: string;
  actions: IWorkflowAction[];
  onCourseChanged?: (course: ICourse) => void;
}) => {

  const { course, actions } = props;

  const [isExpertInviteDialogOpen, setIsExpertInviteDialogOpen] = React.useState(false);
  const [isSubmitSmallChangesDialogOpen, setIsSubmitSmallChangesDialogOpen] = React.useState(false);

  return <HStack spacing="4">
    {course && actions.map(action => (<Tooltip zIndex="1500" key={action.id}  label={action.tooltip}>
      <Box>
        {action.id === 'assign-to-expert'
          ? <Button variant='solid' onClick={() => setIsExpertInviteDialogOpen(true)}>{action.title}</Button>
          : action.id === 'new-small-changes'
            ? <Button colorScheme='gray' variant='solid' onClick={() => setIsSubmitSmallChangesDialogOpen(true)}>{action.title}</Button>
          : <ButtonLink variant='solid' to={`/course/${course.id}/${props.moduleId}/${action.id}`}>{action.title}</ButtonLink>
        }
      </Box>
    </Tooltip>)
    )}
    {isExpertInviteDialogOpen && <AssignToExpertDialog
      course={props.course}
      onClose={() => setIsExpertInviteDialogOpen(false)}
      onExpertChanged={props.onCourseChanged}
    />}
    {isSubmitSmallChangesDialogOpen && <SubmitSmallChangesDialog
      course={props.course}
      onClose={() => setIsSubmitSmallChangesDialogOpen(false)}
    />}

  </HStack>
}